export default function ({
    companyId = this.companyId || this.$store.getters.companyId
}) {
    return {
        system: {
            checkLogin: "/user/self/checkLogin",
            register: "/user/register",
            apply: "/user/apply",
            login: "/user/login",
            logout: "/user/logout",
            sendCode: "/share/Public/sendCode",
            codeLogin: "/user/codeLogin",
            publicCompanyInfo: "/user/publicCompanyInfo",
            applyForTrial: "/user/applyForTrial"
        },
        file: {
            ossToken: "/file/FileAction/apaas-upload/ossToken"
        },
        user: {
            uploadAvatar: "/user/self/FileBackend/uploadAvatar",
            updateInfo: "/user/self/updateInfo",
            getInfo: "/user/self/getInfo",
            changePass: "/user/self/changePass",
            updateMobile: "/user/self/updateMobile",
            getSelfCompanyInfo: "/user/self/companyInfo",
            getUserCompanies: "/user/self/getUserCompanies",
            createCompany: "/user/self/createCompany",
            quitCompany: "/user/self/quitCompany",
            quitApp: "/user/self/quitApp",
            setDefaultCompany: "/user/self/setDefaultCompany"
        },
        company: {
            getInviteUser: `/comp/${companyId}/UserCompany/member/getInviteUser`, // 获取未激活的员工
            getAllUsers: `/comp/${companyId}/UserCompany/member/getAllUser`,
            addCode: `/comp/${companyId}/UserCompany/member/addCode`,
            deleteCode: `/comp/${companyId}/UserCompany/member/deleteCode`,
            getCanAddSubUsers: `/comp/${companyId}/UserCompany/member/getCanAddSubUsers`,
            show: `/comp/${companyId}/Company/member/memberShow`,
            update: `/comp/${companyId}/Company/admin/update`,
            userIndex: `/comp/${companyId}/Company/member/getCompanyUsersWithGrade`,
            deleteUser: `/comp/${companyId}/Company/admin/resign`, // 移除员工
            batchDeleteUser: `/comp/${companyId}/Company/admin/batchResign`, // 批量移除员工
            inviteOther: `/comp/${companyId}/Company/admin/inviteOther`,
            cancelInvite: `/comp/${companyId}/Company/admin/cancelInvite`, // 取消邀请
            updateManageType: `/comp/${companyId}/Company/admin/updateManageType`,
            getUserWithoutDepartment: `/comp/${companyId}/Company/admin/getUserWithoutDepartment`,
            getCompanyApps: `/comp/${companyId}/Company/admin/getCompanyApps`,
            deleteApp: `/comp/${companyId}/Company/admin/deleteApp`,
            getCompanyInfo: `/comp/${companyId}/Company/member/getCompInfo`, // 获取企业人数信息
            getLatestMessage: `/comp/${companyId}/Company/member/getLatestMessage`, // 获取企业公告
            createMessage: `/comp/${companyId}/Company/admin/messageCreate`, // 创建企业公告
            deleteMessage: `/comp/${companyId}/Company/admin/messageSearchDelete`, // 删除企业公告
            updateMessage: `/comp/${companyId}/Company/admin/messageUpdate`, // 更新企业公告
            getAllMessages: `/comp/${companyId}/Company/admin/messageIndex`, // 获取全部企业公告
            getStatistics: `/comp/${companyId}/Company/admin/baseStatistics`, // 获取企业用量统计图表数据
            getUserApps: `/comp/${companyId}/Company/member/getUserApps`,
            getAppMsgCount: `/comp/${companyId}/custom/Company/getAppMsgCount`,
            createApp: `/comp/${companyId}/Company/member/createApp`
        },
        department: {
            gradeCreate: `comp/${companyId}/DepartmentGrade/admin/comp_create`, // 添加公司部门角色
            gradeUpdate: `comp/${companyId}/DepartmentGrade/admin/comp_update`, // 修改公司部门角色
            gradeIndex: `comp/${companyId}/DepartmentGrade/admin/comp_index`, // 公司部门角色列表-admin
            gradeMemberIndex: `comp/${companyId}/DepartmentGrade/member/comp_index`, // 公司部门角色列表-mmber
            gradeDelete: `comp/${companyId}/DepartmentGrade/admin/comp_searchDelete`, // 删除公司部门角色
            departCreate: `/comp/${companyId}/Department/admin/create`,
            departIndex: `/comp/${companyId}/Department/admin/all`,
            departAll: `/comp/${companyId}/Department/member/comp_all`,
            departUpdate: `/comp/${companyId}/Department/admin/update`,
            delDepartment: `/comp/${companyId}/Department/admin/delDepartment`, // 删除部门及下级
            deleteUsersFromDepartment: `/comp/${companyId}/Department/admin/deleteUsersFromDepartment`, // 删除部门的员工
            userAdd: `/comp/${companyId}/Department/admin/addUsersToDepartment`,
            replace: `/comp/${companyId}/Department/admin/replaceUsersDepartment`,
            setPosition: `/comp/${companyId}/Department/admin/setPosition`,
            move: `comp/${companyId}/Department/admin/move`
        },
        app: {
            exportApp: `/comp/${companyId}/InnerApp/exportApp`,
            importApp: `/comp/${companyId}/InnerApp/importApp`,
            importUpdateApp: `/comp/${companyId}/InnerApp/importUpdateApp`
        },
        AppStore: {
            storeIndex: "/comp/store/AppStore/storeIndex",
            checkDownloadStatus: `/comp/${companyId}/Company/member/checkDownloadStatus`,
            download: `/comp/${companyId}/Company/admin/download`
        },
        DbStore: {
            getPackageData: `/comp/${companyId}/data/CompMod/index`, // 数据包
            getPackageFlag: `/comp/${companyId}/data/DbStore/getPackageFlag`, // 数据包状态
            getPackageAll: `/comp/${companyId}/data/CompDb/getPackageAll`, // 我拥有的数据包
            getPackageStatus: `/comp/${companyId}/store/DbStore/getPackageStatus`, // 购买数据包是否过期状态
            all: `/comp/${companyId}/store/DbPackage/index`,
            show: `/comp/${companyId}/store/DbPackage/showPackage`,
            download: `/comp/${companyId}/data/DbStore/download`,
            purchase: `/comp/${companyId}/data/DbStore/purchase`
        }
    };
};



// WEBPACK FOOTER //
// ./src/data/system/httpPathMap.js